import { APActivity } from "@/apps/tatar/activityApp/ActivityInterfaces";
import { APOffer } from "@/apps/tatar/activityApp/views/details/offer-feature/APOffer.Interface";
import ModalManager from "@/components/ModalComponent/ModalManager";
import VacancyContractDigitalSigning from "../signing/VacancyContractDigitalSigning";
import VacancyContractWizzard from "../form-parts/VacancyContractWizzard";
import { VacancyApplication } from "../../../model/VacancyApplicant.interface";
import i18n from "@/i18n";
import { useActivityConstants } from "@/apps/tatar/activityApp/ActivityHooks";
import { useActivityStruct } from "@/apps/tatar/activityApp/ActivityStructContext";
import { VacancyContractDigitalSignerConfig } from '../../../model/VacancyContract.interface';

const useVacancyContractDetailsActions = () => {
  const constants = useActivityConstants();
  const activityStruct = useActivityStruct();
  const structData = activityStruct?.getAllData() || [];
  const vacancyConfig = structData.find((s) => {
    return s.data.activity_type === `activity-${constants.serviceUrl}`;
  }) as any;

  const digitalRentalAgreementSigners: VacancyContractDigitalSignerConfig[] =
    vacancyConfig?.data?.digitalRentalAgreementSigners || [];

  const openContractCreationModal = (params: {
    application: VacancyApplication;
    activity: APActivity;
    offer: APOffer;
    reload: () => void;
  }) => {
    const { application, activity, offer, reload } = params;
    ModalManager.show({
      noPadding: true,
      closable: false,
      ignoreEscapeToClose: true,
      content: (
        _states: any,
        _setStates: (states: any) => void,
        closeModal?: () => void
      ) => (
        <VacancyContractWizzard
          activity={activity}
          application={application}
          offer={offer}
          closeModal={closeModal}
          reload={reload}
        />
      ),
      size: "fluid",
    });
  };

  const openContractSigningModal = (params: {
    activity: APActivity;
    offer: APOffer;
    reload: () => void;
  }) => {
    const { activity, offer, reload } = params;

    ModalManager.show({
      content: (
        _states: any,
        _setStates: (states: any) => void,
        closeModal?: () => void
      ) => {
        return (
          <VacancyContractDigitalSigning
            activity={activity}
            offer={offer}
            closeModal={closeModal}
            reload={reload}
          />
        );
      },
      size: "lg",
      title: i18n.t(
        "apTemplate:Vacancy.Applicant.ContractDetails.Label.SigningContract",
        "Mietvertrag unterzeichnen"
      ),
      headerCloseButton: true,
      buttons: [
        {
          text: i18n.t("common:Button.Close", "Schließen"),
          closeOnClick: true,
        },
      ],
    });
  };

  return {
    openContractCreationModal,
    openContractSigningModal,
    digitalRentalAgreementSigners,
  };
};

export default useVacancyContractDetailsActions;
